package team.platforma.multiplatform_material_extension.ui.drop_down.model

data class ListItem(
    val id: Long,
    val title: String,
    val parent: ListItem? = null
)
